import * as Ant from "antd";

import React from "react";
import styled from "styled-components";

export function Collapse({
  children,
  ...props
}: React.ComponentProps<typeof Ant.Collapse>) {
  return (
    <Collapse.Container>
      <Ant.Collapse {...props}>{children}</Ant.Collapse>
    </Collapse.Container>
  );
}

export namespace Collapse {
  export const Panel = Ant.Collapse.Panel;
  export const Container = styled.div`
    & .ant-collapse {
      background: none;
    }

    & .ant-collapse-header {
      font-weight: 500;
      & .ant-collapse-extra {
        font-weight: normal;
      }
    }
  `;
}
